import React from 'react'
import BallySportsMLB from 'src/components/page/bally-sports-mlb'
import { videos } from 'src/constants/videos'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => (
  <BallySportsMLB
    location={props.location}
    video={videos.bally_diamondbacks.videoUrl}
    title="Watch Arizona baseball live"
    subtitle="Stream Diamondbacks games all season long"
    teamId={teamIds['Arizona Diamondbacks']}
  />
)
